import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import CustomBookingId from "../../../components/CustomBookingId/CustomBookingId";
import { StyledSummaryPaymentDetail } from "../components/PaymentMethodSelection.styles";
import Section from "../components/Section";
import RichTextRender from "../../../components/RichTextRender/RichTextRender";
import { isEmpty } from "lodash";
import PaymentDescription from "../../../components/PaymentsDescription/PaymentDescription";

const BasePaymentMethodScreen = ({
  transactionCustomId,
  summary,
  paymentInformation,
  supplierData,
  title,
  children,
  descriptionTitle,
}) => {
  const { t } = useTranslation(["shop", "common"]);

  return (
    <Card>
      <CustomBookingId customId={transactionCustomId} />
      {summary && (
        <Section title={t("paymentSummary")}>
          <StyledSummaryPaymentDetail {...summary} />
        </Section>
      )}
      {title && <Title level={5}>{title}</Title>}
      {!isEmpty(paymentInformation.description) ? (
        <RichTextRender
          style={{ fontSize: 18, lineHeight: 1.5 }}
          content={paymentInformation.description}
        />
      ) : (
        <PaymentDescription
          paymentInformation={paymentInformation}
          country={supplierData?.country}
          title={descriptionTitle}
        />
      )}
      {children}
    </Card>
  );
};

BasePaymentMethodScreen.propTypes = {
  transactionCustomId: PropTypes.string.isRequired,
  summary: PropTypes.object,
  paymentInformation: PropTypes.object.isRequired,
  supplierData: PropTypes.object.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  descriptionTitle: PropTypes.string.isRequired,
};

export default BasePaymentMethodScreen;
